// Constructeurs de données structurées schema.org pour Gwada Nuisibles.
export const SITE_URL = 'https://nuisibles-guadeloupe.fr';
const NAME = 'Gwada Nuisibles';
const PHONE = '+33980803684';

// Entité organisation/entreprise locale, réutilisée par référence (@id).
export const ORG_ID = SITE_URL + '/#business';

export function localBusiness() {
  return {
    '@context': 'https://schema.org',
    '@type': 'PestControl',
    '@id': ORG_ID,
    name: NAME,
    url: SITE_URL,
    image: SITE_URL + '/og-image.png',
    telephone: PHONE,
    description:
      "Dératisation, désinsectisation et traitement des nuisibles à domicile partout en Guadeloupe : rats, ravets, termites, punaises de lit, scolopendres, moustiques.",
    areaServed: [
      { '@type': 'AdministrativeArea', name: 'Guadeloupe', containedInPlace: { '@type': 'Country', name: 'France' } },
      { '@type': 'City', name: 'Pointe-à-Pitre' },
      { '@type': 'City', name: 'Les Abymes' },
      { '@type': 'City', name: 'Baie-Mahault' },
      { '@type': 'City', name: 'Le Gosier' },
      { '@type': 'City', name: 'Petit-Bourg' },
      { '@type': 'City', name: 'Sainte-Anne' },
      { '@type': 'City', name: 'Le Moule' },
      { '@type': 'City', name: 'Basse-Terre' },
    ],
    address: { '@type': 'PostalAddress', addressRegion: 'Guadeloupe', addressCountry: 'GP' },
    geo: { '@type': 'GeoCoordinates', latitude: 16.265, longitude: -61.551 },
    availableLanguage: 'fr',
    priceRange: '€€',
    knowsAbout: [
      'Dératisation', 'Désinsectisation', 'Traitement des termites',
      'Punaises de lit', 'Scolopendres', 'Démoustication',
    ],
  };
}

export function website() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': SITE_URL + '/#website',
    url: SITE_URL,
    name: NAME,
    inLanguage: 'fr-FR',
    publisher: { '@id': ORG_ID },
  };
}

export function breadcrumb(items: Array<{ name: string; path: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: SITE_URL + (it.path === '/' ? '/' : it.path),
    })),
  };
}

export function faqPage(items: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((it) => ({
      '@type': 'Question',
      name: it.question,
      acceptedAnswer: { '@type': 'Answer', text: it.answer },
    })),
  };
}

export function service(opts: { name: string; serviceType: string; path: string; description: string }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: opts.name,
    serviceType: opts.serviceType,
    url: SITE_URL + opts.path,
    description: opts.description,
    provider: { '@id': ORG_ID },
    areaServed: { '@type': 'AdministrativeArea', name: 'Guadeloupe' },
    availableChannel: {
      '@type': 'ServiceChannel',
      serviceUrl: SITE_URL + '/soumission',
      servicePhone: PHONE,
    },
  };
}

export function article(opts: { headline: string; description: string; path: string; image?: string }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: opts.headline,
    description: opts.description,
    inLanguage: 'fr-FR',
    image: opts.image || SITE_URL + '/og-image.png',
    mainEntityOfPage: { '@type': 'WebPage', '@id': SITE_URL + opts.path },
    author: { '@id': ORG_ID },
    publisher: { '@id': ORG_ID },
  };
}
